// react
import React from "react";

// dependencies
import PropTypes from "prop-types";

// components
import Button from "Components/Button";
import Modal from "Components/Modal";

// styles
import css from "./DeletedObjectConfirmationModal";

const DeletedObjectConfirmationModal = (props) => {
	const { handleConfirm, handleCancel, message } = props;

	const content = (
		<div className={css.modalContent}>
			<p>{message}</p>
		</div>
	);

	const buttons = (
		<div>
			<div className={css.deletedObjectConfirmationModalButtons}>
				<div className={css.modalButton}>
					<Button version={2} color="green" onClick={handleConfirm}>
						Undelete
					</Button>
				</div>
				<div className={css.modalButton}>
					<Button version={2} color="red" onClick={handleCancel}>
						Cancel
					</Button>
				</div>
			</div>
		</div>
	);

	return <Modal content={content} buttons={buttons} handleClose={handleCancel} />;
};

DeletedObjectConfirmationModal.propTypes = {
	handleConfirm: PropTypes.func.isRequired,
	handleCancel: PropTypes.func.isRequired,
	message: PropTypes.string.isRequired,
};

export default DeletedObjectConfirmationModal;
